import { render } from "./RegistrationAwaiting.vue?vue&type=template&id=fd93f996&scoped=true&ts=true"
import script from "./RegistrationAwaiting.vue?vue&type=script&lang=ts"
export * from "./RegistrationAwaiting.vue?vue&type=script&lang=ts"

import "./RegistrationAwaiting.vue?vue&type=style&index=0&id=fd93f996&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd93f996"]])

export default __exports__